// src/resources/sections/dataConfig.ts
import type { ResourceConfig } from "../resourceTypes";
export const AUTH_CONFIG: ResourceConfig[] = [
  /*
  {
    name: "credentials",
    label: "Auth Credentials",
    schema: "auth",
    fields: [
      {
        source: "cred_name",
        label: "Credential name",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "username",
        label: "Username",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "auth_method",
        label: "Auth method",
        kind: "text",
        list: true,
        form: true,
        defaultValue: "password,ssh_key,agent",
      },
      {
        source: "password_present",
        label: "Password present",
        kind: "boolean",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "ssh_key_present",
        label: "SSH key present",
        kind: "boolean",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "agent_certificate_present",
        label: "Agent cert present",
        kind: "boolean",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "updated_at",
        label: "Updated at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["cred_name", "username"],
    actions: [
      {
        kind: "rpc",
        label: "Ensure Keys",
        rpcName: "ensure_ssh_keys_for_credential",
        method: "POST",
        row: true,
        schema: "ssh",
        sendRecord: false,
        useIdAs: "p_cred_id",
      },
      {
        kind: "rpc",
        label: "Rotate ed25519",
        rpcName: "rotate_ssh_keypair",
        method: "POST",
        row: true,
        schema: "ssh",
        useIdAs: "p_cred_id",
        payload: {
          p_key_type: "ed25519",
        },
        sendRecord: false,
      },
      {
        kind: "rpc",
        label: "Rotate rsa4096",
        rpcName: "rotate_ssh_keypair",
        method: "POST",
        row: true,
        schema: "ssh",
        useIdAs: "p_cred_id",
        payload: {
          p_key_type: "rsa4096",
        },
        sendRecord: false,
      },
    ],
  },
*/
  {
    name: "credentials_safe",
    label: "Auth Credentials",
    schema: "auth",
    fields: [
      {
        source: "cred_name",
        label: "Credential name",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "username",
        label: "Username",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "auth_method",
        label: "Auth method",
        kind: "text",
        list: true,
        form: true,
        defaultValue: "password,ssh_key,agent",
      },
      {
        source: "password_present",
        label: "Password present",
        kind: "boolean",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "ssh_key_present",
        label: "SSH key present",
        kind: "boolean",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "agent_certificate_present",
        label: "Agent cert present",
        kind: "boolean",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "updated_at",
        label: "Updated at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["cred_name", "username"],
    actions: [
      {
        kind: "rpc",
        label: "Ensure Keys",
        rpcName: "ensure_ssh_keys_for_credential",
        method: "POST",
        row: true,
        //    schema: "ssh",
        sendRecord: false,
        useIdAs: "p_cred_id",
      },
      {
        kind: "rpc",
        label: "Rotate ed25519",
        rpcName: "rotate_ssh_keypair",
        method: "POST",
        row: true,
        //      schema: "ssh",
        useIdAs: "p_cred_id",
        payload: {
          p_key_type: "ed25519",
        },
        sendRecord: false,
      },
      {
        kind: "rpc",
        label: "Rotate rsa4096",
        rpcName: "rotate_ssh_keypair",
        method: "POST",
        row: true,
        useIdAs: "p_cred_id",
        payload: {
          p_key_type: "rsa4096",
        },
        sendRecord: false,
      },
      {
        kind: "rpc",
        label: "Set Password",
        rpcName: "set_credential_password",
        method: "POST",
        row: true,
        useIdAs: "p_cred_id",
        promptPassword: true,
        passwordField: "p_password",
        sendRecord: false,
      },
    ],
  },

  {
    name: "v_keystore_passwords_safe",
    label: "Keystore Passwords",
    schema: "auth",
    fields: [
      {
        source: "name",
        label: "Name",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "password_present",
        label: "Password present",
        kind: "boolean",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "created_at",
        label: "Created at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "updated_at",
        label: "Updated at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["name"],
    actions: [
      {
        kind: "rpc",
        label: "Set Password",
        rpcName: "set_keystore_password_password",
        method: "POST",
        row: true,
        useIdAs: "p_keystore_password_id",
        promptPassword: true,
        passwordField: "p_password",
        sendRecord: false,
      },
    ],
  },
];
